var _g, _line, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 66,
    viewBox: "0 0 113 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98 63.5C104.904 63.5 110.5 57.9036 110.5 51C110.5 44.0964 104.904 38.5 98 38.5C91.0964 38.5 85.5 44.0964 85.5 51C85.5 57.9036 91.0964 63.5 98 63.5Z",
    stroke: "#F3F3F3",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 60.1651,
    y1: 2.0553,
    x2: 90.1651,
    y2: 39.0553,
    stroke: "white",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0310669 2.22424H61.0311",
    stroke: "white",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_29"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(83 36)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdPointer);
export default __webpack_public_path__ + "static/media/ed-pointer.bd77c4fa8cc19c1540883ade7fb349e9.svg";
export { ForwardRef as ReactComponent };